import { render } from "./drawing-review.vue?vue&type=template&id=12da1018"
import script from "./drawing-review.vue?vue&type=script&lang=js"
export * from "./drawing-review.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__